import { render, staticRenderFns } from "./StatsLocalisationsTableComponent.vue?vue&type=template&id=101f741a&"
import script from "./StatsLocalisationsTableComponent.vue?vue&type=script&lang=js&"
export * from "./StatsLocalisationsTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports